import {
    GET_CANDIDATE_FEEDBACK_REQUEST,
    GET_CANDIDATE_FEEDBACK_SUCCESS,
    GET_CANDIDATE_FEEDBACK_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getCandidateFeedBackReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CANDIDATE_FEEDBACK_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_CANDIDATE_FEEDBACK_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_CANDIDATE_FEEDBACK_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getCandidateFeedBackReducer;